import { useState } from 'react'
import { CheckoutBuilder } from '@features/checkout-builder'
import { useAdminRuntimeCapabilities, useAdminUserLookup } from '@features/admin/api/admin.api'
import type { ProductItem } from '@features/admin/api/admin.api'
import {
  AdminProductEditRequestDrawer,
  type AdminProductEditApproval,
} from '@features/admin/ui/AdminProductEditRequestDrawer'
import { AdminProductsScreen } from '@features/admin/ui/AdminProductsScreen'
import { ProductEditor } from '@features/product/ui/ProductEditor'
import { useSession } from '@shared/lib/auth/session-store'
import { hasAdminPermission } from '@shared/lib/auth/permissions'
import { PermissionGate } from '@shared/ui/PermissionGate'

export function ProdutosPage() {
  const session = useSession((state) => state.user)
  const [requestTarget, setRequestTarget] = useState<ProductItem | null>(null)
  const [editorTarget, setEditorTarget] = useState<{
    product: ProductItem
    approval: AdminProductEditApproval
  } | null>(null)
  const [checkoutBuilder, setCheckoutBuilder] = useState<{
    productId: string
    checkoutId?: string
  } | null>(null)
  const producer = useAdminUserLookup(
    hasAdminPermission(session, 'USER_READ') ? (requestTarget?.producerId ?? '') : '',
  )
  const runtimeCapabilities = useAdminRuntimeCapabilities()

  return (
    <PermissionGate permission="PRODUCT_READ">
      <AdminProductsScreen onEditProduct={setRequestTarget} />
      <AdminProductEditRequestDrawer
        key={requestTarget?.id ?? 'closed'}
        product={requestTarget}
        producerEmail={producer.data?.user?.email ?? ''}
        producerName={producer.data?.user?.name}
        onClose={() => setRequestTarget(null)}
        onApproved={(product, approval) => {
          setRequestTarget(null)
          setEditorTarget({ product, approval })
        }}
      />
      <ProductEditor
        open={editorTarget !== null}
        productId={editorTarget?.product.id}
        adminProducerId={editorTarget?.product.producerId}
        minuteBillingEnabled={runtimeCapabilities.data?.minuteBillingEnabled === true}
        approvalContext={editorTarget?.approval}
        onClose={() => setEditorTarget(null)}
        onOpenCheckoutBuilder={(productId, checkoutId) =>
          setCheckoutBuilder({ productId, ...(checkoutId ? { checkoutId } : {}) })
        }
      />
      <CheckoutBuilder
        open={checkoutBuilder !== null}
        productId={checkoutBuilder?.productId}
        initialCheckoutId={checkoutBuilder?.checkoutId}
        onClose={() => setCheckoutBuilder(null)}
      />
    </PermissionGate>
  )
}
